import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { PageInfoFragment } from "@shared/data/fragments/PageInfoFragment/PageInfoFragment.fragment";
import { PAGE_INFO_FRAGMENT } from "@shared/data/fragments/PageInfoFragment/PageInfoFragment.fragment";
import type { SupplementType } from "@shared/types/graphqlGenerated";

const SupplementTypes_Shared_Query = gql`
  query SupplementTypes_Shared_Query($first: Int, $last: Int, $after: String, $before: String) {
    viewer {
      supplementTypes(first: $first, last: $last, after: $after, before: $before) {
        nodes {
          id
          name
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

interface SupplementTypesData {
  viewer: {
    supplementTypes: {
      nodes: SupplementType[];
      pageInfo: PageInfoFragment;
      totalCount: number;
    };
  };
}

interface Variables {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
}

const defaultVariables: Variables = {
  first: 24,
};

const useSupplementTypesQuery = (options?: QueryHookOptions<SupplementTypesData, Variables>) => {
  const { variables } = { variables: {}, ...options };

  return useQuery<SupplementTypesData, Variables>(SupplementTypes_Shared_Query, {
    ...options,
    variables: { ...defaultVariables, ...variables },
  });
};

export type { SupplementTypesData, Variables };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useSupplementTypesQuery, SupplementTypes_Shared_Query };
